export default defineAppConfig({
  icon: {
    cssLayer: 'components',
  },
})
